import { endpoints } from "@/config/endpoints.config"
import { Property } from "@/gen"
import { client } from "@/hooks/useClient"
import { store } from "@/stores/stores"
import { useQuery } from "@tanstack/react-query"
import { UseFormReturn, useWatch } from "react-hook-form"
import { useSnapshot } from "valtio"

export interface useNodeDynamicPropertiesProps {
    node_type: string
    operation_id?: string
    action_id?: string
    depends_on?: string[]
    // properties?: Record<string, any>
    // credentials_id?: string
    enabled?: boolean
    form?: UseFormReturn<any, any, undefined>

    endpointPath?: string
    property_id?: string
}

export function useQueryNodeDynamicProperties(props: useNodeDynamicPropertiesProps) {
    const snap = useSnapshot(store)
    const endpoint = `${endpoints.NODES}/${props.node_type}/${props.action_id}/${props.operation_id}/${props.endpointPath || "dynamic-properties"}`
    const { depends_on, form, endpointPath, ...payload } = props
    const credentials_id = props.form?.getValues("credentials_id")
    // const properties = props.form?.getValues("properties")
    const properties = useWatch({ name: "properties" })

    const credentials = snap.credential.list.find((cred) => cred.id === credentials_id)
    const dependsOnCredentials = (props.depends_on?.filter((key) => key.startsWith("credentials."))?.length || 0) > 0

    const keys = props.depends_on?.reduce((acc, key) => {
        if (key.startsWith("credentials.")) {
            key = key.replace("credentials.", "")
            acc.push(credentials?.properties?.[key] || "")
        } else {
            acc.push(properties?.[key] || "")
        }
        // if (key.startsWith("properties.")) {
        //     key = key.replace("properties.", "")
        //     acc.push(properties?.[key] || "")
        // }
        return acc
    }, [] as string[]) || []

    const enabled = props.enabled && !!props.action_id && !!props.operation_id && !!snap.credential.fetched && (!dependsOnCredentials || (dependsOnCredentials && !!credentials))

    // console.log("useQueryNodeDynamicProperties", [endpoint, props.action_id, props.operation_id, props.property_id, ...keys], props.enabled && !!snap.credential.fetched && (!dependsOnCredentials || (dependsOnCredentials && !!credentials)))
    const queryResult = useQuery({
        queryKey: [endpoint, props.action_id, props.operation_id, props.property_id, ...keys],
        queryFn: () => {
            return client.post<{ properties: Property[]; optional_properties: Property[] }>(endpoint, { ...payload, credentials, properties }).then((res) => {
                return res.data
            })
        },
        enabled,
        staleTime: Infinity,
    })

    return queryResult
}